"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.highlightCode = void 0;
var tslib_1 = require("tslib");
var highlight_js_1 = tslib_1.__importDefault(require("highlight.js"));
require("highlight.js/styles/github.css");
function highlightCode() {
    var blocks = document.querySelectorAll('pre code');
    Array.from(blocks).map(function (block) {
        highlight_js_1.default.highlightBlock(block);
    });
}
exports.highlightCode = highlightCode;
